import { DataBaseModelInterface } from '@solcre-org/core';

export class TariffFormModel implements DataBaseModelInterface {
  constructor(public berthingType: string | null = null) {}

  fromJSON(json: any): TariffFormModel {
    if (json) {
      this.berthingType = json.berthingType ?? null;
    }
    return this;
  }

  toJSON() {
    return { berthingType: this.berthingType };
  }

  getId() {
    return this.berthingType ?? '';
  }

  getReference() {
    return this.berthingType ?? '';
  }
}
